import { IDonateItemService } from './donateItemServiceTypes';

export class DonateItemServiceStub implements IDonateItemService {
	public async exitMenu(): Promise<void> {
		console.log('donateItem:exitMenu');
	}
}
